import { Box, Container, Paper, Stack, Typography } from "@mui/material";

const HowItWorks = () => {
  return (
    <Box
      id="how-it-works"
      sx={{
        py: { xs: 4, md: 4 },
        backgroundColor: "var(--color-arctic)",
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
          <Typography
            sx={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "var(--color-midnight-60)",
              mb: 0.8,
            }}
          >
            HOW IT WORKS
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 800,
              color: "var(--color-midnight)",
              letterSpacing: "-0.015em",
            }}
          >
            Get a realistic{" "}
            <Box component="span" sx={{ color: "var(--color-fiery)" }}>
              project cost in minutes
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 1.2,
              maxWidth: 640,
              mx: "auto",
              fontSize: { xs: "0.9rem", md: "1rem" },
              lineHeight: 1.65,
              color: "var(--color-midnight-70)",
            }}
          >
            A simple, transparent process designed to give you clarity before
            you invest.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2.5, md: 3 },
            mt: { xs: 4, md: 6 },
          }}
        >
          {[
            ["01", "Define your project", "Choose platform, type, and scale"],
            ["02", "Select features", "Pick integrations and functionality"],
            ["03", "Design & timeline", "Set UI/UX level and delivery speed"],
            ["04", "Instant estimate", "Get a realistic cost range instantly"],
          ].map(([step, title, desc]) => (
            <Paper
              key={step}
              elevation={0}
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 48%",
                  md: "1 1 23%",
                },
                p: { xs: 3, md: 4 },
                borderRadius: 2,
                border: "1px solid var(--color-midnight-15)",
                background:
                  "linear-gradient(180deg, #FFFFFF 0%, rgba(246,247,235,0.7) 100%)",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  color: "var(--color-fiery)",
                  mb: 1,
                }}
              >
                {step}
              </Typography>

              <Typography fontWeight={700} mb={0.5}>
                {title}
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.9rem",
                  color: "var(--color-midnight-70)",
                }}
              >
                {desc}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorks;
